import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { AuthProvider } from '../auth/AuthProvider';
import { AccessDenied, PermissionRoute, ProtectedRoute, PublicOnlyRoute, SessionRedirect } from './AuthRoutes';
import MainLayout from '../layouts/MainLayout';
import LoginPage from '../pages/login/LoginPage';
import DashboardPage from '../pages/dashboard/DashboardPage';
import WarehousesPage from '../pages/warehouses/WarehousesPage';
import CustomersPage from '../pages/customers/CustomersPage';
import CustomerDetailsPage from '../pages/customers/CustomerDetailsPage';
import InventoryPage from '../pages/inventory/InventoryPage';
import PackagingTypesPage from '../pages/inventory/PackagingTypesPage';
import UnitsPage from '../pages/inventory/UnitsPage';
import ContainerPlanningPage from '../pages/container-planning/ContainerPlanningPage';
import UsersPage from '../pages/users/UsersPage';
import UserPermissionsPage from '../pages/users/UserPermissionsPage';
import CreateUserPage from '../pages/users/CreateUserPage';
import SettingsPage from '../pages/settings/SettingsPage';

export default function AppRoutes() {
  return <AuthProvider><Routes>
    <Route path="/" element={<SessionRedirect />} />
    <Route path="/login" element={<PublicOnlyRoute><LoginPage /></PublicOnlyRoute>} />
    <Route element={<ProtectedRoute />}>
      <Route element={<MainLayout />}>
        <Route path="/access-denied" element={<AccessDenied />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route element={<PermissionRoute module="Dashboard" />}><Route path="/dashboard" element={<DashboardPage />} /></Route>
        <Route element={<PermissionRoute module="Warehouse" />}><Route path="/warehouses" element={<WarehousesPage />} /></Route>
        <Route element={<PermissionRoute module="Customers" />}><Route path="/customers" element={<CustomersPage />} /><Route path="/customers/:customerId" element={<CustomerDetailsPage />} /></Route>
        <Route element={<PermissionRoute module="Inventory" />}><Route path="/inventory" element={<InventoryPage />} /></Route>
        <Route element={<PermissionRoute module="PackagingTypes" />}><Route path="/packaging-types" element={<PackagingTypesPage />} /></Route>
        <Route element={<PermissionRoute module="Units" />}><Route path="/units" element={<UnitsPage />} /></Route>
        <Route element={<PermissionRoute module="ContainerPlanning" />}><Route path="/container-planning" element={<ContainerPlanningPage />} /></Route>
        <Route element={<PermissionRoute module="Users" />}>
          <Route path="/users" element={<UsersPage />} />
          <Route path="/users/:userId/permissions" element={<UserPermissionsPage />} />
        </Route>
        <Route element={<PermissionRoute module="Users" write />}>
          <Route path="/users/create" element={<CreateUserPage />} />
        </Route>
      </Route>
    </Route>
    <Route path="*" element={<main style={{ padding: '3rem', fontFamily: 'system-ui' }}><h1>Page not found</h1><a href="/login">Return to sign in</a></main>} />
  </Routes></AuthProvider>;
}
